import { Empty, Loaded, Loading, Updating } from 'core/state';

export type State<T> = Empty | Loading | Loaded<T> | Updating<T>;

export type SetState<T> = (next: T) => void;

export type UseStateResult<T> = [State<T>, SetState<T>];

export const State = {
  map:
    <T, R>(mapper: (value: T) => R) =>
    (state: State<T>): State<R> => {
      switch (state[0]) {
        case 'just':
          return Loaded(mapper(state[1]));
        case 'updating':
          return Updating(mapper(state[1]), mapper(state[2]));
        default:
          return state;
      }
    },
};
